import React from 'react'
import { StopsCard } from '../../../components'
import { dateAsCalendar, penaltyAsCalendar } from '../../../helpers'
import { IPenalty } from '../../../models'
import StyledDiv from './styles'

interface IProps {
  penalty: IPenalty
}

export const PenaltyCard: React.FC<IProps> = ({ penalty }) => {
  return (
    <StyledDiv>
      <span className="date">{ dateAsCalendar(penalty.date, false) }</span>
      <StopsCard
        inStopName={ penalty.beginningStop.name }
        outStopName={ penalty.seats[0].exitStop.name }
        noColors
      />
      <span className="expiration">{ penaltyAsCalendar(penalty.expirationDate) }</span>
    </StyledDiv>
  )
}
